/* eslint-disable */
import { useState, useEffect, useRef } from "react";

const LAB_PASSWORD = "footylab2025"; // Change this to whatever you want
const SERVER      = "http://localhost:5151"; // Your laptop's lab server

const COLOURS = ["red","blue","navy","green","yellow","white","black","orange","purple","pink","cyan","maroon","amber","lime","grey"];

export default function Lab() {
  const [authed,    setAuthed]    = useState(false);
  const [pw,        setPw]        = useState("");
  const [pwError,   setPwError]   = useState(false);
  const [serverOk,  setServerOk]  = useState(null); // null=checking, true=ok, false=down
  const [file,      setFile]      = useState(null);
  const [home,      setHome]      = useState("blue");
  const [away,      setAway]      = useState("red");
  const [startMin,  setStartMin]  = useState("");
  const [endMin,    setEndMin]    = useState("");
  const [sample,    setSample]    = useState("5");
  const [uploading, setUploading] = useState(false);
  const [uploadPct, setUploadPct] = useState(0);
  const [jobId,     setJobId]     = useState(null);
  const [jobStatus, setJobStatus] = useState(null);
  const [report,    setReport]    = useState(null);
  const [drag,      setDrag]      = useState(false);
  const pollRef   = useRef(null);
  const xhrRef    = useRef(null);

  // Check if session is already authed
  useEffect(() => {
    if (sessionStorage.getItem("lab_auth") === "1") setAuthed(true);
  }, []);

  // Check server health when authed
  useEffect(() => {
    if (!authed) return;
    checkServer();
    const t = setInterval(checkServer, 10000);
    return () => clearInterval(t);
  }, [authed]);

  // Poll job status
  useEffect(() => {
    if (!jobId) return;
    pollRef.current = setInterval(async () => {
      try {
        const r = await fetch(`${SERVER}/status/${jobId}`);
        const d = await r.json();
        setJobStatus(d);
        if (d.status === "done") {
          clearInterval(pollRef.current);
          setReport(d.result);
        }
        if (d.status === "error") {
          clearInterval(pollRef.current);
        }
      } catch {}
    }, 3000);
    return () => clearInterval(pollRef.current);
  }, [jobId]);

  const checkServer = async () => {
    try {
      const r = await fetch(`${SERVER}/health`, { signal: AbortSignal.timeout(3000) });
      setServerOk(r.ok);
    } catch {
      setServerOk(false);
    }
  };

  const login = () => {
    if (pw === LAB_PASSWORD) {
      sessionStorage.setItem("lab_auth", "1");
      setAuthed(true);
    } else {
      setPwError(true);
      setTimeout(() => setPwError(false), 1500);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault(); setDrag(false);
    const f = e.dataTransfer?.files?.[0] || e.target.files?.[0];
    if (f) setFile(f);
  };

  const upload = () => {
    if (!file || !serverOk) return;
    setUploading(true); setUploadPct(0); setJobId(null); setJobStatus(null); setReport(null);
    const fd = new FormData();
    fd.append("video", file);
    fd.append("home", home); fd.append("away", away);
    fd.append("sample", sample);
    if (startMin) fd.append("start", startMin);
    if (endMin)   fd.append("end", endMin);
    const xhr = new XMLHttpRequest();
    xhrRef.current = xhr;
    xhr.upload.addEventListener("progress", e => {
      if (e.lengthComputable) setUploadPct(Math.round(e.loaded / e.total * 100));
    });
    xhr.addEventListener("load", () => {
      setUploading(false);
      try {
        const d = JSON.parse(xhr.responseText);
        if (d.jobId) setJobId(d.jobId);
        else alert("Upload failed: " + (d.error || "unknown error"));
      } catch { alert("Server error"); }
    });
    xhr.addEventListener("error", () => { setUploading(false); alert("Upload failed — is lab.py running?"); });
    xhr.open("POST", `${SERVER}/upload`);
    xhr.send(fd);
  };

  const reset = () => {
    setFile(null); setJobId(null); setJobStatus(null); setReport(null);
    setUploading(false); setUploadPct(0);
  };

  const fmt = n => n >= 1024*1024*1024 ? `${(n/1024/1024/1024).toFixed(1)}GB` : `${(n/1024/1024).toFixed(0)}MB`;

  // ── LOGIN SCREEN ──────────────────────────────────────────────
  if (!authed) return (
    <div style={S.page}>
      <div style={S.loginWrap}>
        <div style={S.loginBadge}>FA</div>
        <div style={S.loginTitle}>ANALYST LAB</div>
        <div style={S.loginSub}>Private access only</div>
        <input
          type="password" placeholder="Password" value={pw}
          onChange={e=>setPw(e.target.value)} onKeyDown={e=>e.key==="Enter"&&login()}
          style={{...S.input, borderColor: pwError?"#8b2a2a":"#2a2520", marginBottom:"0.75rem"}}
          autoFocus/>
        {pwError && <div style={{color:"#f87171",fontSize:"0.72rem",marginBottom:"0.5rem"}}>Wrong password</div>}
        <button onClick={login} style={S.btn}>Enter →</button>
      </div>
    </div>
  );

  // ── MAIN LAB ─────────────────────────────────────────────────
  return (
    <div style={S.page}>
      {/* Header */}
      <div style={S.header}>
        <div>
          <div style={S.headerTitle}>Analyst Lab</div>
          <div style={S.headerSub}>Private · Video Analysis Portal</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:"0.75rem"}}>
          <div style={{...S.dot, background: serverOk===null?"#555":serverOk?"#16a34a":"#8b2a2a"}}/>
          <span style={{fontSize:"0.65rem",color:"#888",fontWeight:600,letterSpacing:"1px"}}>
            {serverOk===null?"Checking...":serverOk?"Lab server connected":"Lab server offline"}
          </span>
          {!serverOk && serverOk!==null && (
            <span style={{fontSize:"0.6rem",color:"#555"}}>Run lab.py on your laptop</span>
          )}
        </div>
      </div>

      <div style={S.body}>

        {/* Server offline banner */}
        {serverOk===false && (
          <div style={S.banner}>
            <div style={{fontWeight:800,marginBottom:"0.25rem"}}>Lab server not running</div>
            <div style={{fontWeight:300,fontSize:"0.72rem",opacity:0.8}}>
              Open Terminal, go to the folder with lab.py, and run: <code style={S.code}>pip install flask flask-cors</code> then <code style={S.code}>python lab.py</code> — keep that window open.
            </div>
          </div>
        )}

        {/* Report view */}
        {report && <ReportView report={report} onBack={reset}/>}

        {/* Processing view */}
        {jobId && !report && (
          <div style={S.card}>
            <div style={S.cardHead}>Processing</div>
            <div style={S.cardBody}>
              <div style={{display:"flex",alignItems:"center",gap:"0.65rem",marginBottom:"0.75rem"}}>
                <div style={{width:10,height:10,borderRadius:"50%",background:"#2e7d7a",animation:"pulse 1s infinite"}}/>
                <div style={{fontWeight:700,color:"#e8e4de"}}>
                  {jobStatus?.status==="done"?"Complete ✓":jobStatus?.status==="error"?"Failed ✗":"Running processor.py on your laptop..."}
                </div>
              </div>
              <div style={{fontSize:"0.72rem",color:"#888",fontFamily:"monospace",minHeight:20,marginBottom:"1rem"}}>
                {jobStatus?.progress || "Starting..."}
              </div>
              <div style={S.progressBar}>
                <div style={{...S.progressFill, width: jobStatus?.status==="done"?"100%":jobStatus?.status==="processing"?"65%":"15%"}}/>
              </div>
              {jobStatus?.status==="error" && (
                <div style={{...S.banner,marginTop:"0.75rem"}}>
                  Error: {jobStatus.error}<br/>
                  <span style={{fontWeight:300,fontSize:"0.72rem"}}>Check the terminal window where lab.py is running.</span>
                </div>
              )}
              <button onClick={reset} style={{...S.btn, marginTop:"1rem", background:"transparent", border:"1px solid #2a2520", color:"#666"}}>
                Start again
              </button>
            </div>
          </div>
        )}

        {/* Upload form */}
        {!jobId && !report && (
          <>
            {/* Drop zone */}
            <div style={S.card}>
              <div style={S.cardHead}>1 — Select Video</div>
              <div style={S.cardBody}>
                <div
                  style={{...S.dropZone, borderColor: drag?"#2e7d7a":file?"#16a34a":"#2a2520", background: file?"rgba(22,163,74,0.06)":"transparent"}}
                  onDragOver={e=>{e.preventDefault();setDrag(true);}}
                  onDragLeave={()=>setDrag(false)}
                  onDrop={handleDrop}
                  onClick={()=>!file&&document.getElementById("vid-input").click()}>
                  <input id="vid-input" type="file" accept="video/*" style={{display:"none"}} onChange={handleDrop}/>
                  {file ? (
                    <>
                      <div style={{fontSize:"2rem",marginBottom:"0.5rem"}}>🎬</div>
                      <div style={{fontWeight:800,color:"#e8e4de",marginBottom:"0.2rem"}}>{file.name}</div>
                      <div style={{fontSize:"0.72rem",color:"#888",marginBottom:"0.75rem"}}>{fmt(file.size)}</div>
                      <button onClick={e=>{e.stopPropagation();setFile(null);}} style={{...S.btn,width:"auto",padding:"0.3rem 0.85rem",fontSize:"0.62rem",background:"transparent",border:"1px solid #2a2520",color:"#666"}}>
                        Remove
                      </button>
                    </>
                  ) : (
                    <>
                      <div style={{fontSize:"2.5rem",marginBottom:"0.65rem"}}>📹</div>
                      <div style={{fontWeight:700,color:"#ccc",marginBottom:"0.25rem"}}>Drop video here</div>
                      <div style={{fontSize:"0.72rem",color:"#666"}}>or click to browse — MP4, MOV, AVI, MKV</div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Kit colours */}
            <div style={S.card}>
              <div style={S.cardHead}>2 — Kit Colours</div>
              <div style={S.cardBody}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"1rem"}}>
                  <div>
                    <label style={S.label}>Your team (home)</label>
                    <div style={{display:"flex",flexWrap:"wrap",gap:"0.3rem",marginTop:"0.4rem"}}>
                      {COLOURS.map(c=>(
                        <button key={c} onClick={()=>setHome(c)}
                          style={{padding:"0.25rem 0.6rem",fontSize:"0.65rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",
                            border:`1.5px solid ${home===c?"#2e7d7a":"#2a2520"}`,
                            background:home===c?"#2e7d7a":"transparent",
                            color:home===c?"#fff":"#888",transition:"all 0.12s"}}>
                          {c}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label style={S.label}>Opposition (away)</label>
                    <div style={{display:"flex",flexWrap:"wrap",gap:"0.3rem",marginTop:"0.4rem"}}>
                      {COLOURS.map(c=>(
                        <button key={c} onClick={()=>setAway(c)}
                          style={{padding:"0.25rem 0.6rem",fontSize:"0.65rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",
                            border:`1.5px solid ${away===c?"#8b2a2a":"#2a2520"}`,
                            background:away===c?"#8b2a2a":"transparent",
                            color:away===c?"#fff":"#888",transition:"all 0.12s"}}>
                          {c}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Options */}
            <div style={S.card}>
              <div style={S.cardHead}>3 — Options (optional)</div>
              <div style={S.cardBody}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"0.85rem"}}>
                  <div>
                    <label style={S.label}>Start minute</label>
                    <input type="number" placeholder="0" value={startMin} onChange={e=>setStartMin(e.target.value)} style={S.input} min="0"/>
                  </div>
                  <div>
                    <label style={S.label}>End minute</label>
                    <input type="number" placeholder="90" value={endMin} onChange={e=>setEndMin(e.target.value)} style={S.input} min="0"/>
                  </div>
                  <div>
                    <label style={S.label}>Sample rate</label>
                    <select value={sample} onChange={e=>setSample(e.target.value)} style={S.input}>
                      <option value="3">3 (accurate)</option>
                      <option value="5">5 (balanced)</option>
                      <option value="10">10 (fast)</option>
                    </select>
                  </div>
                </div>
                <div style={{fontSize:"0.65rem",color:"#555",marginTop:"0.65rem",fontStyle:"italic"}}>
                  Sample rate 5 = every 5th frame. A 90-min match takes ~8-15 mins on your laptop.
                </div>
              </div>
            </div>

            {/* Upload button + progress */}
            {uploading ? (
              <div style={S.card}>
                <div style={S.cardBody}>
                  <div style={{fontWeight:700,color:"#e8e4de",marginBottom:"0.5rem"}}>Uploading {uploadPct}%</div>
                  <div style={S.progressBar}>
                    <div style={{...S.progressFill,width:`${uploadPct}%`}}/>
                  </div>
                  <div style={{fontSize:"0.65rem",color:"#666",marginTop:"0.35rem"}}>Do not close this tab</div>
                </div>
              </div>
            ) : (
              <button
                onClick={upload}
                disabled={!file || !serverOk}
                style={{...S.btn, background:file&&serverOk?"#d4941a":"#2a2520", color:file&&serverOk?"#1a1612":"#444", cursor:file&&serverOk?"pointer":"default"}}>
                {!serverOk?"Start lab.py on your laptop first":!file?"Select a video first":`Analyse ${file?file.name:""} →`}
              </button>
            )}
          </>
        )}
      </div>
      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.3}}`}</style>
    </div>
  );
}

// ── REPORT COMPONENT ─────────────────────────────────────────────
function ReportView({ report, onBack }) {
  const s = report?.report?.summary || {};
  const findings = report?.report?.findings || [];
  const events   = report?.report?.events   || [];
  const windows  = s.windows || [];
  const meta     = report?.meta || {};

  const colVal = (v, good, warn) => v <= good ? "#16a34a" : v <= warn ? "#d4941a" : "#8b2a2a";
  const maxPress = Math.max(...windows.map(w=>w.avg_pressing||0), 0.1);

  return (
    <div>
      {/* Report header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"1.2rem",flexWrap:"wrap",gap:"0.5rem"}}>
        <div>
          <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.6rem",letterSpacing:"3px",color:"#e8e4de"}}>Tactical Report</div>
          <div style={{fontSize:"0.68rem",color:"#666",marginTop:"0.1rem"}}>{meta.video} · {meta.home_colour} vs {meta.away_colour} · {s.duration_mins?.toFixed(0)} mins</div>
        </div>
        <div style={{display:"flex",gap:"0.5rem"}}>
          <button onClick={()=>window.print()} style={{...S.btn,width:"auto",padding:"0.4rem 0.9rem",fontSize:"0.65rem",background:"#2e7d7a",color:"#fff"}}>🖨 Print</button>
          <button onClick={onBack} style={{...S.btn,width:"auto",padding:"0.4rem 0.9rem",fontSize:"0.65rem",background:"transparent",border:"1px solid #2a2520",color:"#888"}}>← New Analysis</button>
        </div>
      </div>

      {/* Key stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:"0.5rem",marginBottom:"1.2rem"}}>
        {[
          {l:"Pressing Avg", v:(s.avg_pressing?.home||0).toFixed(1), c:colVal(s.avg_pressing?.home||0,0,1.4)},
          s.press_success!=null&&{l:"Press Success", v:`${s.press_success}%`, c:s.press_success>=65?"#16a34a":s.press_success>=40?"#d4941a":"#8b2a2a"},
          {l:"Shape Area",   v:(s.avg_compactness||0).toFixed(0), c:colVal(s.avg_compactness||0,0,1800)},
          {l:"Formation",    v:s.formation||"—", c:"#2e7d7a"},
          {l:"Press Triggers",v:s.events?.press_triggers||0, c:"#d4941a"},
          {l:"Shape Breaks", v:s.events?.shape_breaks||0, c:"#8b2a2a"},
          s.avg_def_line&&{l:"Def Line /100", v:(s.avg_def_line||0).toFixed(0), c:s.avg_def_line>75?"#8b2a2a":s.avg_def_line<45?"#16a34a":"#d4941a"},
          {l:"Frames",       v:s.frames||0, c:"#555"},
        ].filter(Boolean).map((item,i)=>(
          <div key={i} style={{background:"#0f0d0a",border:"1px solid #2a2520",padding:"0.65rem 0.75rem",textAlign:"center"}}>
            <div style={{fontSize:"1.4rem",fontWeight:900,letterSpacing:"1px",color:item.c,lineHeight:1}}>{item.v}</div>
            <div style={{fontSize:"0.52rem",fontWeight:700,letterSpacing:"1.5px",textTransform:"uppercase",color:"#555",marginTop:"0.2rem"}}>{item.l}</div>
          </div>
        ))}
      </div>

      {/* Pressing by period */}
      {windows.filter(w=>w.frames>0).length>0&&(
        <div style={{...S.card,marginBottom:"1rem"}}>
          <div style={S.cardHead}>Pressing by Period</div>
          <div style={S.cardBody}>
            {windows.filter(w=>w.frames>0).map((w,i)=>{
              const val=w.avg_pressing||0; const pct=Math.round(val/maxPress*100);
              const barCol=val<1.2?"#8b2a2a":val>2.5?"#16a34a":"#2e7d7a";
              return(
                <div key={i} style={{display:"flex",alignItems:"center",gap:"0.65rem",marginBottom:"0.35rem"}}>
                  <div style={{fontSize:"0.65rem",color:"#888",width:55,flexShrink:0}}>{w.label}</div>
                  <div style={{flex:1,height:8,background:"#2a2520",borderRadius:2,overflow:"hidden"}}>
                    <div style={{height:"100%",width:`${pct}%`,background:barCol,borderRadius:2}}/>
                  </div>
                  <div style={{fontSize:"0.72rem",fontWeight:700,color:barCol,width:28,textAlign:"right"}}>{val.toFixed(1)}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Findings */}
      {findings.length>0&&(
        <div style={{...S.card,marginBottom:"1rem"}}>
          <div style={S.cardHead}>Tactical Findings</div>
          <div style={S.cardBody}>
            {findings.map((f,i)=>{
              const cols={high:"#8b2a2a",medium:"#d4941a",positive:"#16a34a"};
              const c=cols[f.severity]||"#2e7d7a";
              return(
                <div key={i} style={{borderLeft:`4px solid ${c}`,padding:"0.85rem 1rem",marginBottom:"0.65rem",background:`${c}0d`}}>
                  <div style={{fontWeight:800,color:"#e8e4de",marginBottom:"0.2rem",display:"flex",alignItems:"center",gap:"0.4rem"}}>
                    <span style={{fontSize:"0.55rem",fontWeight:800,letterSpacing:"1px",textTransform:"uppercase",background:c,color:"#fff",padding:"0.1rem 0.35rem"}}>{f.severity}</span>
                    {f.title}
                  </div>
                  <div style={{fontSize:"0.72rem",color:"#888",fontWeight:600,marginBottom:"0.2rem"}}>{f.data}</div>
                  <div style={{fontSize:"0.75rem",color:"#aaa",fontWeight:300,lineHeight:1.65,marginBottom:"0.4rem"}}>{f.detail}</div>
                  <div style={{fontSize:"0.72rem",color:"#2e7d7a",fontWeight:700,borderLeft:"2px solid #2e7d7a",paddingLeft:"0.5rem",lineHeight:1.55}}>{f.action}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Events */}
      {events.length>0&&(
        <div style={S.card}>
          <div style={S.cardHead}>Event Timeline ({events.length})</div>
          <div style={S.cardBody}>
            {[...events].sort((a,b)=>a.ts-b.ts).map((e,i)=>{
              const cols={press_trigger:"#2e7d7a",shape_breakdown:"#d4941a",opp_press:"#8b2a2a"};
              const c=cols[e.type]||"#555";
              return(
                <div key={i} style={{display:"flex",gap:"0.6rem",alignItems:"flex-start",padding:"0.3rem 0",borderBottom:"1px solid #2a2520"}}>
                  <div style={{fontFamily:"monospace",fontSize:"0.72rem",color:"#d4941a",fontWeight:700,width:40,flexShrink:0}}>{e.time}</div>
                  <div style={{fontSize:"0.55rem",fontWeight:800,letterSpacing:"1px",textTransform:"uppercase",background:c,color:"#fff",padding:"0.1rem 0.35rem",flexShrink:0,marginTop:"0.05rem"}}>{e.type.replace(/_/g," ")}</div>
                  <div style={{fontSize:"0.72rem",color:"#aaa",flex:1,lineHeight:1.5}}>{e.detail}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Styles ───────────────────────────────────────────────────────
const S = {
  page:        {background:"#0f0d0a",minHeight:"100vh",fontFamily:"'DM Sans',sans-serif"},
  loginWrap:   {display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:"100vh",padding:"2rem"},
  loginBadge:  {width:52,height:52,background:"#d4941a",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.3rem",color:"#1a1612",marginBottom:"1rem"},
  loginTitle:  {fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.8rem",letterSpacing:"4px",color:"#e8e4de",marginBottom:"0.25rem"},
  loginSub:    {fontSize:"0.65rem",color:"#555",letterSpacing:"2px",textTransform:"uppercase",marginBottom:"1.5rem"},
  header:      {background:"#1a1612",borderBottom:"2px solid #2a2520",padding:"0.85rem 1.5rem",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:"0.5rem"},
  headerTitle: {fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.1rem",letterSpacing:"3px",color:"#d4941a"},
  headerSub:   {fontSize:"0.58rem",color:"#555",letterSpacing:"1.5px",textTransform:"uppercase",marginTop:"0.1rem"},
  body:        {maxWidth:720,margin:"0 auto",padding:"1.5rem"},
  card:        {background:"#1a1612",border:"1.5px solid #2a2520",marginBottom:"1rem"},
  cardHead:    {padding:"0.6rem 1rem",borderBottom:"1px solid #2a2520",fontSize:"0.6rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"#555"},
  cardBody:    {padding:"1rem"},
  btn:         {display:"block",width:"100%",padding:"0.85rem",fontFamily:"'DM Sans',sans-serif",fontSize:"0.78rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",cursor:"pointer",border:"none",transition:"all 0.18s",textAlign:"center"},
  input:       {width:"100%",background:"#0f0d0a",border:"1.5px solid #2a2520",borderBottom:"2px solid #3a3530",color:"#e8e4de",fontFamily:"inherit",fontSize:"0.85rem",padding:"0.55rem 0.8rem",outline:"none"},
  label:       {fontSize:"0.58rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"#555",display:"block",marginBottom:"0.35rem"},
  dropZone:    {border:"2px dashed",padding:"2rem",textAlign:"center",cursor:"pointer",transition:"all 0.2s"},
  progressBar: {height:6,background:"#2a2520",borderRadius:3,overflow:"hidden"},
  progressFill:{height:"100%",background:"#2e7d7a",borderRadius:3,transition:"width 0.5s"},
  banner:      {background:"rgba(139,42,42,0.15)",border:"1.5px solid #8b2a2a",borderLeft:"4px solid #8b2a2a",padding:"0.85rem 1rem",color:"#f87171",fontSize:"0.78rem",marginBottom:"1rem",lineHeight:1.65},
  dot:         {width:8,height:8,borderRadius:"50%"},
  code:        {background:"#2a2520",padding:"0.1rem 0.4rem",fontFamily:"monospace",fontSize:"0.75rem",color:"#d4941a"},
};
